module.exports = __webpack_public_path__ + "img/paishui5.85ba679f.png";